<template>
  <div>
    <sub-menu :title="title" :routes="routes"></sub-menu>

    <router-view class="mt-6"></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SubMenu from '@/components/SubMenu.vue'

export default {
  data() {
    return {
      title: 'my_settings',
    }
  },
  components: {
    SubMenu,
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
    routes() {
      const routes = [{ path: '/profile', title: 'personal_details' }]
      if (this.User && !this.User.isDemo) {
        routes.push({ path: '/profile/upload-documents', title: 'upload_documents' })
        routes.push({ path: '/profile/guidance-documents', title: 'guidance_documents' })
      }
      return routes
    },
  },
}
</script>
